module.exports = __webpack_public_path__ + "img/list Payroll active.8b132207.svg";